// src/features/scope_module/components/DemoHeader.js
import React from 'react';
import { Crosshair, XCircle, Info } from 'lucide-react';
import { useScope } from '../../../contexts/DemoScopeContext';

const DemoHeader = () => {
    const { onExit } = useScope();
  return (
    <header className="scope-header">
      <div className="scope-header-left">
        <div className="scope-header-title">
            <h1>
                <Crosshair size={22} />
                SCOPE
            </h1>
            <span className="scope-header-subtitle">TouchBase SCOPE (DEMO MODE)</span>
        </div>
      </div>

      <div className="scope-header-badges">
          <div className="scope-badge">
              <Info size={14} />
              <span className="scope-badge-label">Mode</span>
              <span className="scope-badge-value">Interactive Demo</span>
          </div>
          
          <button 
            className="toolbar-btn danger" 
            onClick={onExit}
            style={{ marginLeft: '1rem', padding: '0.25rem 0.75rem', height: 'auto' }}
          >
            <XCircle size={16} />
            <span>Exit Demo</span>
          </button>
      </div>
    </header>
  );
};

export default DemoHeader;